import React, { FunctionComponent, useEffect, useState } from 'react';

import styles from './NotificationReleaseNote.module.scss';
import { formatDistance } from 'date-fns';
import { constants, getFromLocalStorage } from 'app/utils/localStorage';
import { arMA, enUS } from 'date-fns/locale';
import { useMutation, useQuery } from 'react-query';
import {
  getReleaseNoteNotification,
  setReleaseNoteNotificationMark,
} from 'settings/Requests';
import { CloseIcon, ReleaseNoteIcon } from 'app/assets/images/icons';
import { useHistory } from 'react-router-dom';
import { path } from 'app/utils/path';
import { _t } from 'app/utils/i18n';
import Loader from 'app/components/Loader';

interface Props {}

const NotificationReleaseNote: FunctionComponent<Props> = ({}) => {
  const dirc = getFromLocalStorage('LNG');
  const [dir] = useState<string | null>(dirc);
  const history = useHistory();
  const { data: notification, isLoading, refetch } = useQuery(
    'releaseNoteNotification',
    getReleaseNoteNotification
  );
  const {
    mutateAsync: markNotification,
    isLoading: isMarkingNotification,
  } = useMutation(
    'releaseNoteNotificationMark',
    setReleaseNoteNotificationMark
  );

  const openHandler = async () => {
    await markNotification();
    history.push(
      `${
        getFromLocalStorage(constants.user)?.site_admin
          ? path.settings.RELEASE_NOTES_DETAILS_URL
          : path.users.RELEASE_NOTES_DETAILS_URL
      }/${notification?.id}`
    );
  };
  const closeHandler = async () => {
    await markNotification();
  };

  useEffect(() => {
    refetch();
  }, [isMarkingNotification]);

  if (!notification?.id) return <></>;

  return (
    <div className={styles.NotificationReleaseNote}>
      <div className={styles.image}>
        <ReleaseNoteIcon
          style={{
            width: 40,
            height: 40,
          }}
        />
      </div>
      <div className={styles.notifications}>
        <div className={styles.notificationsFlex}>
          <div className={styles.titleContainer}>
            <div className={styles.notifications_b}>
              <b>{notification?.title}</b>
            </div>
            <div className={styles.date}>
              <b onClick={openHandler}>{_t('settings:view_release_notes')}</b>
              {formatDistance(new Date(notification?.created_on), new Date(), {
                locale: dir === 'ar' ? arMA : enUS,
              })}
            </div>
          </div>
        </div>
      </div>
      <CloseIcon
        width={12.5}
        height={12.5}
        style={{
          marginBlockStart: 10,
          marginInlineEnd: 10,
          alignSelf: 'flex-start',
        }}
        onClick={closeHandler}
      />
      {isLoading || (isMarkingNotification && <Loader overlay />)}
    </div>
  );
};

export default NotificationReleaseNote;
